import loadable from '@loadable/component'

export default [
  {
    path: '/SocialRelationships',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SocialRelationships-index" */ '~/pages/SocialRelationships/pages/index'
        )
    ),
  },
  {
    path: '/SocialRelationships/set',
    exact: true,
    component: loadable(
        () =>
            import(
                /* webpackChunkName: "page-SocialRelationships-set" */ '~/pages/SocialRelationships/pages/set'
                )
    ),
  },
  {
    path: '/SocialRelationships/bagPack',
    exact: true,
    component: loadable(
        () =>
            import(
                /* webpackChunkName: "page-SocialRelationships-bagPack" */ '~/pages/SocialRelationships/pages/bagPack'
                )
    ),
  },
  {
    path: '/SocialRelationships/relationHalfPop',
    exact: true,
    component: loadable(
        () =>
            import(
                /* webpackChunkName: "page-SocialRelationships-relationHalfPop" */ '~/pages/SocialRelationships/components/relationHalfPop'
                )
    ),
  },
  {
    path: '/SocialRelationships/buy',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SocialRelationships-buy" */ '~/pages/SocialRelationships/pages/buy'
        )
    ),
  },
  {
    path: '/SocialRelationships/roomBanner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SocialRelationships-roomBanner" */ '~/pages/SocialRelationships/pages/roomBanner'
        )
    ),
  },
  {
    path: '/SocialRelationships/popUp',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SocialRelationships-popUp" */ '~/pages/SocialRelationships/pages/popUp'
        )
    ),
  },
  {
    path: '/SocialRelationships/banner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SocialRelationships-banner" */ '~/pages/SocialRelationships/pages/banner'
        )
    ),
  },
]
